import React from 'react';
import { StoreModules } from '~/lib/data-contract';
import { MapMarker } from '~/features/find-store/components/StoreMap/models';
import { StoreBlock } from '../StoreBlock/StoreBlock';

type Props = {
    elements: StoreModules[];
    storeList?: MapMarker;
};

export const StoreBlockList = ({ elements, storeList }: Props) => {
    if (!elements?.length) {
        return null;
    }

    return (
        <>
            {elements.map((element, index) => (
                <StoreBlock
                    key={element.id}
                    element={element}
                    index={index}
                    storeList={storeList}
                />
            ))}
        </>
    );
};
